import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { KPIIcon, CourseIcon, DashBoardIcon, MyDashBoardIcon, SupportIcon, MyCertificateIcon } from '../../SvgIconsData'
// import { PiChartLineUp } from 'react-icons/pi'

const Sidebar = ({ sideBar, setSideBar }) => {
  var location = useLocation();
  var navigate = useNavigate();
  const userData = useSelector(state => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (userData?.user?.permissions?.length > 0) {
      setPermissions([...userData.user.permissions])
    }
  }, [userData.user]);

  useEffect(() => {
    var path = location.pathname;
    var active = 'dashboard';
    if (path.startsWith('/dashboard')) active = 'dashboard';
    else if (path.startsWith('/team-dashboard')) active = 'team-dashboard';
    else if (path.startsWith('/leaderboard')) active = 'leaderboard';
    else if (path.startsWith('/traits')) active = 'traits';
    setActiveTab(active);
  }, [location.pathname]);


  return (
    <div className='mainside'>
      <div className={sideBar ? 'sidmenu active' : 'sidmenu'}>
        <div className='mainsidelist'>
          <ul>
          {/* {permissions.includes("CONTENT.VIEW") &&
            <li onClick={() => navigate(`/dashboard/`, { state: userData.user })} className={`${activeTab == 'dashboard' ? 'active' : ''}`}>
            <MyDashBoardIcon />
            <p className='ms-3'>My Dashboard</p>
          </li>
              } */}

          {permissions.includes("PSY.DASHBOARD.MY") &&
            <li onClick={() => navigate(`/`, { state: userData.user })} className={`${activeTab == 'dashboard' ? 'active' : ''}`}>
            <MyDashBoardIcon />
            <p className='ms-3'>My Dashboard</p>
          </li>
              }
              {/* {permissions.includes("PSY.DASHBOARD.TEAM") &&
              <li onClick={() => navigate(`/team-dashboard/`, { state: userData.user.group })} className={`${activeTab == 'team-dashboard' ? 'active' : ''}`}>
                <DashBoardIcon />
                <p className='ms-3'>Team Dashboard</p>
              </li>}
              {permissions.includes("PSY.DASHBOARD.LEADERBOARD") &&
              <li onClick={() => navigate('/leaderboard/')} className={`${activeTab == 'leaderboard' ? 'active' : ''}`}>
                <CourseIcon />
                <p className='ms-3'>Leaderboard</p>
              </li>} */}
              {permissions.includes("PSY.TRAITS") &&
              <li onClick={() => navigate(`/traits/`, { state: { user: userData.user } })} className={`${activeTab == 'traits' ? 'active' : ''}`}>
                <MyCertificateIcon />
                <p className='ms-3'>Game Traits & Play</p>
              </li> }
          </ul>
        </div>
      </div>
    </div>
  )

  /////
  /* return (
    <div className='mainside'>
      <div className={sideBar ? 'sidmenu active' : 'sidmenu'}>
        <div className='mainsidelist'>
          <ul>
          
              <li onClick={() => navigate(`/dashboard/`, { state: userData.user })} className={`${activeTab == 'dashboard' ? 'active' : ''}`}>
                <MyDashBoardIcon />
                <p className='ms-3'>My Dashboard</p>
              </li>
        
              <li onClick={() => navigate(`/team-dashboard/`, { state: userData.user.group })} className={`${activeTab == 'team-dashboard' ? 'active' : ''}`}>
                <DashBoardIcon />
                <p className='ms-3'>Team Dashboard</p>
              </li>
   
              <li onClick={() => navigate('/leaderboard/')} className={`${activeTab == 'leaderboard' ? 'active' : ''}`}>
                <CourseIcon />
                <p className='ms-3'>Leaderboard</p>
              </li>
         
              <li onClick={() => navigate(`/traits/`, { state: { user: userData.user } })} className={`${activeTab == 'traits' ? 'active' : ''}`}>
                <MyCertificateIcon />
                <p className='ms-3'>Traits</p>
              </li>
          </ul>
        </div>
      </div>
    </div>
  ) */
}

export default Sidebar